import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { amountOfCharactersValidator } from '@shared/validators';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'provider-search',
    templateUrl: './provider-search.component.html',
    styleUrls: ['./provider-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProviderSearchComponent {
  @Input() providerLabel = 'Provider';

  @Output() search = new EventEmitter<string>();

  private readonly MAX_LENGTH = 10;

  form = new FormGroup({
    npi: new FormControl('', [
      Validators.required,
      amountOfCharactersValidator(this.MAX_LENGTH)
    ])
  });

  onSubmit(): void {
    const npi = this.form.get('npi').value;

    if (npi) {
      this.search.emit(npi);
    }
  }

}
